import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=38a6590f&"
import script from "./FileDropzone.vue?vue&type=script&lang=js&"
export * from "./FileDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports